import accounts from '@/helpers/accountsIframe';

export interface PostPaymentApiData {
  contractId: string;
  partner: string;
  externalId: string;
}

export interface PostPaymentApiResponse {
  success: boolean;
  message?: string;
  data?: any;
}

export interface UnicoGetPaymentApiResponse {
  success: boolean;
  message?: string;
}
/**
 * Chama API externa após geração de pagamento
 * TODO: Definir URL e estrutura final da API
 */
export async function callPostPaymentApi(
  data: PostPaymentApiData,
): Promise<PostPaymentApiResponse> {
  try {
    const baseUrl =
      process.env.VUE_APP_POST_PAYMENT_API_URL || 'https://api.example.com/post-payment';
    const apiUrl = process.env.VUE_APP_POST_PAYMENT_API_URL
      ? `${baseUrl}/contract-partner-relation`
      : baseUrl;

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accounts.getTokenD()}`,
      },
      body: JSON.stringify({
        contractId: Number(data.contractId),
        partner: data.partner,
        externalId: data.externalId,
        category: 'Graduação',
      }),
    });

    if (!response.ok) {
      throw new Error(`API call failed with status: ${response.status}`);
    }

    const result = await response.json();

    return {
      success: true,
      data: result,
    };
  } catch (error) {
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Unknown error',
    };
  }
}

export async function callUnicoGetPaymentApi(): Promise<UnicoGetPaymentApiResponse> {
  try {
    const partnerData = window.POCKET.getPartnerDataFromCookie('d-partner');

    if (!partnerData) {
      return {
        success: false,
        message: 'Partner data not found',
      };
    }

    const partnerToken = partnerData.token;

    if (!partnerToken) {
      return {
        success: false,
        message: 'Partner token not found',
      };
    }

    const apiUrl =
      process.env.VUE_APP_POST_PAYMENT_API_URL || 'https://api.example.com/post-payment';

    const response = await fetch(`${apiUrl}/unico-skill/confirm-enrollment?token=${partnerToken}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accounts.getTokenD()}`,
      },
    });

    if (!response.ok) {
      return {
        success: false,
        message: `Unico GET API call failed with status: ${response.status}`,
      };
    }

    await response.json();

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Unknown error',
    };
  }
}

export function preparePostPaymentData(studentAcademicRecord: string): PostPaymentApiData | null {
  if (typeof window === 'undefined' || !studentAcademicRecord) return null;

  const partnerData = accounts.getPartnerDataFromCookie('d-partner');

  if (!partnerData || !partnerData.partnerProperty) {
    return null;
  }

  const { partnerProperty } = partnerData;

  return {
    contractId: studentAcademicRecord,
    partner: partnerData.partner as string,
    externalId: partnerData[partnerProperty] as string,
  };
}
